import { RadioGroup, TextField } from '@oy/uidesktop';
import { useEnv, useTranslate } from 'src/hooks';
import { ViewOnlyDetail } from 'src/pages/MultiAccount/ChildrenList/components/AddChildModal/ViewOnlyDetail/ViewOnlyDetail';
import { FirstStepForm } from '../../constants';

export const ChildTypeStep = ({
  formState,
  setFormState,
}: {
  formState: FirstStepForm;
  setFormState: (state: FirstStepForm) => void;
}) => {
  const { getTranslation } = useTranslate();
  const { isProdEnv } = useEnv();

  return (
    <div>
      <TextField
        value={formState.username}
        onChange={e => setFormState({ username: e.target.value })}
        label="Username sub-entity"
        helpText="Username ini akan menerima undangan untuk menyambung akunnya."
        disabled={!isProdEnv}
      />
      <RadioGroup
        value={formState.legality}
        onChange={e => setFormState({ legality: e.target.value })}
        label={getTranslation('multiEntity_addSubentity_question1')}
        isDisabled={!isProdEnv}
        options={[
          {
            label: getTranslation('multiEntity_addSubentity_question1_yes'),
            value: 'true',
            description: getTranslation(
              'multiEntity_addSubentity_question1_yes_description',
            ),
          },
          {
            label: getTranslation('multiEntity_addSubentity_question1_no'),
            value: 'false',
            description: getTranslation(
              'multiEntity_addSubentity_question1_no_description',
            ),
          },
        ]}
      />
      <RadioGroup
        value={formState.childType}
        onChange={e => setFormState({ childType: e.target.value })}
        label={getTranslation('multiAccount_header_childType')}
        isDisabled={!isProdEnv}
        options={[
          {
            value: 'TRANSACTING',
            label: getTranslation('add_child_type_transacting'),
            description: getTranslation(
              'add_child_type_transacting_description',
            ),
          },
          {
            value: 'VIEWONLY',
            label: getTranslation('add_child_type_view_only'),
            description: getTranslation('add_child_type_view_only_description'),
          },
        ]}
      />
      {formState.childType === 'VIEWONLY' && <ViewOnlyDetail />}
    </div>
  );
};
